<template>
    <b-button-group>
        <b-button
            v-for="year in options"
            :key="year"
            :variant="buttonVariant(year)"
            size="sm"
            @click="select(year)"
        >
            {{ year }}
        </b-button>
    </b-button-group>
</template>

<script>
export default {
    props: {
        options: {
            type: Array,
            required: true
        },
        value: {
            type: Number,
            required: true
        }
    },

    methods: {
        select(year) {
            this.$emit("input", year);
            this.$emit("change", year);
        },
        buttonVariant(year) {
            return year === this.value ? "primary" : "outline-primary";
        }
    }
};
</script>
